import { render, staticRenderFns } from "./landing-page-general-info.vue?vue&type=template&id=18920b7c&scoped=true&lang=pug"
import script from "./landing-page-general-info.js?vue&type=script&lang=js&external"
export * from "./landing-page-general-info.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-general-info.vue?vue&type=style&index=0&id=18920b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18920b7c",
  null
  
)

export default component.exports